import * as React from "react";
import styled from "styled-components";
import { WmkImage } from "wmk-image";
import { WmkLink } from "wmk-link";
import { IconCopyButton } from "../../../../classes/IconButtonsRow";
import { colors } from "../../../../vars/palette";

const Wrap = styled.div`
  width: 7rem;
  margin: .5rem 2rem;
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    p {
      color: white;
      text-align: center;
      line-height: 1.5rem;
    }
    &:hover {
      p {
        color: ${colors.hex('primary')};
      }
    }
  }

`;
const ImageWrap = styled.div`
  height: 6.5rem;
  display: flex;
  align-items: center;
`

const BlockIconCopyButton = ({ block }: { block: IconCopyButton }) => {
  // console.log("block: ", block);
  const { icon, link } = block;
  const buttonCopy = block?.buttonCopy;
  return (
    <Wrap>
      <WmkLink to={link}>
        <ImageWrap>
          <WmkImage image={icon} />
        </ImageWrap>        
        {buttonCopy && <p>{buttonCopy}</p>}
      </WmkLink>
    </Wrap>
  );
};

export default BlockIconCopyButton;
